import * as actions from './paymentConstants';

import getClient from 'api';
import {
  addCustomError,
  addGlobalError,
  startLoading,
  stopLoading,
} from 'components';
import {
  ADD_PAYMENT_ERROR_MESSAGE,
  CREDIT_CARD_PATH,
  DELETE_CREDIT_CARD_PATH,
  INTERNAL_SERVER_ERROR_CODE,
  PAYMENT_DEFAULT_PATH,
  PAYMENTS_PATH,
  POST_ECHECK_PATH,
} from 'constant';
import { paymentOptions, getLastThreeDigits } from 'utils';

const client = getClient();

const PAYMENT_UUID_HEADER = {
  'nextiva-context-paymentIdType': 'UUID',
};

//ADD_PAYMENT_METHODS
export const addPaymentMethods = payload => ({
  type: actions.ADD_PAYMENT_METHODS,
  payload,
});

/**
 * Get payment method list.
 *
 * @param {string} billToSiteNumber
 */
export const startAddPaymentMethods = billToSiteNumber => async dispatch => {
  dispatch(startLoading());

  return client
    .get(PAYMENTS_PATH, { params: { billToSiteNumber } })
    .then(response => {
      dispatch(addPaymentMethods(response.data));
      dispatch(stopLoading());
    })
    .catch(error => {
      dispatch(addGlobalError(error));
      dispatch(stopLoading());
    });
};

//ADD_PAYMENT_METHOD
export const addPaymentMethod = payload => ({
  type: actions.ADD_PAYMENT_METHOD,
  payload,
});

/**
 * Executes endpoint to add a payment method.
 */
export const startAddPaymentMethod = payload => async dispatch => {
  dispatch(startLoading());

  const urlAPI =
    paymentOptions.CREDIT_CARD === payload.paymentOption
      ? CREDIT_CARD_PATH
      : POST_ECHECK_PATH;

  return client
    .post(urlAPI, payload, {
      params: { billToSiteNumber: payload.billToSiteNumber },
      headers: PAYMENT_UUID_HEADER,
    })
    .then(response => {
      dispatch(
        addPaymentMethod({
          ...response.data,
          echeckSuffix:
            paymentOptions.ECHECK === payload.paymentOption
              ? getLastThreeDigits(payload.accountNumber)
              : null,
          status: 0,
        })
      );
      dispatch(stopLoading());
    })
    .catch(error => {
      error?.response?.status === INTERNAL_SERVER_ERROR_CODE
        ? dispatch(addCustomError(ADD_PAYMENT_ERROR_MESSAGE))
        : dispatch(addGlobalError(error));
      dispatch(stopLoading());
      return error;
    });
};

/**
 * Sets default payment method in the reducer.
 *
 * @param {string} paymentMethodUuid
 */
export const setDefaultPayment = paymentMethodUuid => ({
  type: actions.SET_DEFAULT_PAYMENT,
  payload: paymentMethodUuid,
});

/**
 * Set default payment method.
 */
export const startSetDefaultPayment = payload => async (dispatch, getState) => {
  const {
    corpAcctNbr,
    paymentMethodUuid,
    subscriberId,
  } = getState().summary.defaultPaymentMethod;
  const billToSiteNumber = getState().billingLanding.activeLocation.locationId;

  const bodyPayload = payload || {
    corpAcctNbr,
    paymentMethodUuid,
    subscriberId,
  };

  dispatch(startLoading());
  return client
    .put(PAYMENT_DEFAULT_PATH, bodyPayload, {
      params: { billToSiteNumber },
      headers: PAYMENT_UUID_HEADER,
    })
    .then(() => {
      dispatch(setDefaultPayment(bodyPayload.paymentMethodUuid));
      dispatch(stopLoading());
    })
    .catch(error => {
      dispatch(addGlobalError(error));
      dispatch(stopLoading());
      return error;
    });
};

//SET_VANTIV_RESPONSE
export const setVantivResponse = payload => ({
  type: actions.SET_VANTIV_RESPONSE,
  payload,
});

//SET_VANTIV_RESPONSE_EMPTY
export const setVantivResponseEmpty = () => ({
  type: actions.SET_VANTIV_RESPONSE_EMPTY,
});

/**
 * Specifies delete credit card action for reducer.
 */
export const setDeleteCreditCard = () => ({
  type: actions.SET_DELETE_CREDIT_CARD,
});

/**
 * Delete a credit card by uuid.
 *
 * @param {string} paymentMethodUuid payment method uuid.
 * @param {string} billToSiteNumber bill to site number.
 */
export const startDeleteCreditCard = ({
  paymentMethodUuid,
  billToSiteNumber,
}) => async dispatch => {
  return client
    .delete(`${DELETE_CREDIT_CARD_PATH}/${paymentMethodUuid}`, {
      params: { billToSiteNumber },
      headers: PAYMENT_UUID_HEADER,
    })
    .then(({ data }) => {
      if (data) {
        dispatch(setDeleteCreditCard());
        dispatch(startAddPaymentMethods(billToSiteNumber));
      } else {
        const error = { data };
        dispatch(addGlobalError(error));
        dispatch(stopLoading());
        return error;
      }
    })
    .catch(error => {
      dispatch(addGlobalError(error));
      dispatch(stopLoading());
      return error;
    });
};
